// @flow
import classnames from 'classnames';

import css from '@styles/catalogFilters';

import type { Node } from 'react';

type TProps = {
  children: Node,
  className?: string,
  show: boolean,
  ElementType?: string
};

function FilterRadioItems({
  children,
  className,
  show,
  ElementType = 'ul'
}: TProps) {
  return show ? (
    <ElementType className={classnames(css.contentDropdown, className)}>
      {children}
    </ElementType>
  ) : null;
}

export default FilterRadioItems;
